<template>
  <div class="sheetComparePage">
    <div v-show="leftConfig.bgShow">
      <!-- @click="exchangeCaseDo" -->
      <div class="show-left-content-box" @click="exchangeCaseDo">
        <img :src="leftIconImg" />
      </div>
      <Transition name="slide-fade">
        <!-- :style="{width: rightConfig.leftWidth}" -->
        <div class="left-content-box" v-show="leftConfig.isShow" :style="{width: rightConfig.leftWidth}">
          <div class="left-box" v-for="model in leftCaseTitleList" :key="model">
            <div class="resetBtn" @click="resetCaseAllDo(model)">
              <img src="@/assets/reset-high-icon.png" />
            </div> 
            <!-- <el-tooltip effect="light" v-for="item in model.list" :content="item.name" :disabled="true" placement="right" :key="item" > -->
              <el-button class="left-btn" v-for="item in model.list" :key="item" :style="btnStyle(item)" @dblclick="doubleSelectCaseDo(item, model)" @click="singleSelectCaseDo(item, model)">{{ item.name }}</el-button>
            <!-- </el-tooltip>       -->
          </div>
        </div>
      </Transition>
    </div>
    <div v-show="rightConfig.bgShow">
      <div class="show-right-content-box" @click="exchangeDo">
        <img :src="iconImg" />
      </div>
      <Transition name="slide-fade">
        <!-- :style="{width: rightConfig.leftWidth}" -->
        <div class="right-content-box" v-show="rightConfig.isShow" :style="{width: rightConfig.leftWidth}">
          <div class="content-box">
            <div class="right-box" v-for="caseModel in caseTitleList" :key="caseModel">
              <div class="resetBtn" @click="resetAllDo(caseModel)">
                <img src="@/assets/reset-high-icon.png" />
              </div>
              <!-- <el-tooltip effect="light" v-for="item in caseModel.list" :content="item.name" :disabled="!item.showTip" placement="left" :key="item" > -->
                <el-button class="left-btn" v-for="item in caseModel.list" :key="item" :style="btnStyle(item)" @click="selectTitleDo(item, caseModel)">{{ item.name }}</el-button> 
              <!-- </el-tooltip> -->
            </div>
          </div>
          <div class="left-bottom-box">
            <p class="bottom-top-p">formula</p>
            <div class="left-bottom-btn-box">
              <el-button class="btn" @click="dataPercentDo" :style="compleftConfigStyle">data / ref</el-button>
              <el-button class="btn" @click="dataDifferDo" :style="compRightConfigStyle">data - ref</el-button>
            </div>
          </div>
        </div>
      </Transition>
    </div>
    <!-- :style="{marginRight: rightConfig.bgMarginLeft}" -->
    <div class="bg" ref="refBg" >
      <div v-show="showMore">
        <div class="top-box">
          <div class="top-url-box">
            <div class="top-line"></div>
            <div class="top-url">
              <a :href="leftInfo.url" target="__blank">{{ leftInfo.url }}</a>
            </div>
          </div>
          <div class="top-row-line"></div>
          <div class="top-url-box top-url-right-box">
            <div class="top-line top-line-right"></div>
            <div class="top-url">
              <a :href="rightInfo.url" target="__blank">{{ rightInfo.url }}</a>
            </div>
          </div>
        </div>
        <div class="info-box-bg">
          <div class="info-box">
            <div class="info-left-box" v-if="leftInfo.list.length > 0">
              <div
                class="info-left-row-box"
                v-for="item in leftInfo.list"
                :key="item"
              >
                <div class="info-left-line"></div>
                <div class="info-left-title">{{ titleCase(item.title) }}</div>
                <div class="info-left-value">{{ item.value ? item.value : "-" }}</div>
              </div>
            </div>
            <div class="info-line"></div>
            <div class="info-right-box" v-if="rightInfo.list.length > 0">
              <div
                class="info-right-row-box"
                v-for="item in rightInfo.list"
                :key="item"
              >
                <div class="info-right-value">{{ item.value ? item.value : "-"}}</div>
                <div class="info-right-title">{{ titleCase(item.title) }}</div>
                <div class="info-right-line"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info-bootom-box" @click="clickDo">
        <div class="info-bootom-title">{{ getBottomTitle() }}</div>
        <img :src="getBottomImg()" />
      </div>
      <div class="table-box" ref="tableBox">
        <!-- getTableHeight(tableDataList) -->
        <el-table
          v-loading="loading"
          element-loading-background="rgba(255, 255, 255, 0.8)"
          :data="tableDataList"
          tooltip-effect="light"
          class="table"
          ref="dragTable"
          :height="tableH"
          border
          :header-cell-style="{
            background: '#f5f5f5',
            borderColor: '#f5f5f5',            
          }"
          scrollbar-always-on>
          <el-table-column fixed align="center" :width="trialMaxWidth">
            <template #header>
              <div class="trial-box" :style="{minHeight: maxHeaderLineH}" v-show="originTableDataList.length > 1">
                <div class="header-title">Trial</div>
                <div class="header-box-bottom">
                  <SearchTool ref="searchTool" @searchKeyWords="searchKeyWords"></SearchTool>
                </div>
              </div>
            </template>
            <template #default="scope">
              <div class="no-bg">
                <div class="no">{{scope.$index + 1 }}</div>
                <div class="no-name">{{ scope.row.name }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="280" v-for="(item, index) in columnsList" :key="item">
            <template #header>
              <div class="header-bg" :style="{minHeight: maxHeaderLineH}">
                <div class="header-column-title">
                  {{ item.showName }}
                </div>
                <div class="header-bottom">
                  <div class="bottom bottom1"></div>
                  <div class="bottom bottom2"></div>
                  <div class="bottom bottom3" :style="{backgroundColor: compBackGroundColor(item)}" @click="compSortClick(item)"></div>
                </div>
                <img src="@/assets/questionnaire-line.png" v-show="index==0" @click="popCompareDo"/>
              </div>
            </template>
            <template #default="scope">
              <div class="row-bg">
                <div class="row row1" :style="getRowStyle(scope.row[item.name]?.leftM)" @click="pushPage(scope.row.leftTrialid)"> {{getItemValue(scope.row[item.name]?.leftM)}}</div>
                <div class="row row2" :style="getRowStyle(scope.row[item.name]?.rightM)" @click="pushPage(scope.row.rightTrialid)"> {{getItemValue(scope.row[item.name]?.rightM)}}</div>
                <div class="row row3" :style="{background: getCompareColor(scope.row[item.name])}">
                  {{ getCompareValue(scope.row[item.name]) }}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <CompareClickDialog v-show="compStyle.isShow" :left="compStyle.left" :top="compStyle.top" @missDo="missDo"></CompareClickDialog>
  </div>
</template>
<script>
import {
  getQueryStatus,
  getQueryMetricsBySheet,
  updateTrialSheet
} from "@/request/api";
import { getStrWidthBySpan, CompareState } from "@/utils/common"
import CompareClickDialog from "@/components/CompareClickDialog.vue"
import SearchTool from "@/components/SearchTool.vue";
const SETTIMEOUT = 200
const MAX_LEFT_BTN_WIDTH = 150
const MIN_LEFT_BTN_WIDTH = 60
const COLUMNS_LEN = 10
import {
  ResourceType,
  // RunnerStatus,
} from "@/ginkgo-grpc/jslang/proto/services/rbf_service_pb";
export default {
  name: "sheetComparePage",
  data() {
    return {
      leftLists: [
        {
          title: "Title",
          value: "Title",
        },
        {
          title: "Description",
          value: "Description",
        },
      ],
      rowsList: [],
      columnsList: [],
      originColumnsList: [],
      scrollColumnsList: [],
      leftInfo: {
        url: "",
        list: [],
        allList: [],
      },
      rightInfo: {
        url: "",
        list: [],
        allList: [],
      },
      dataList: [],
      compareDataList: [],
      leftColumnsList: [],
      rightColumnsList: [],
      showMore: false,
      testList:[],
      tableDataList: [],
      originTableDataList: [],
      compRise: false,
      loading: true,
      selectHeaderName: "",
      trialMaxWidth: 230,
      cliclNum: 0,
      clickTimer: null,
      preferMax: true,
      leftRowList: [],
      rightRowList: [],
      compStyle: {
        top: "",
        left: "",
        isShow: false
      },
      caseTitleList:[],
      leftCaseTitleList:[],
      rightConfig: {
        disabled: false,
        isShow: false,
        leftWidth: '180px',
        bgMarginLeft: '',
        bgLeft: 0,
        bgShow: true,
      },
      leftConfig: {
        isShow: false,
        bgShow: true
      },
      doubleConfig: {
        clickNum: 0,
        doubleTimer: null,
      },
      tableH: 60,
      oriTableH: 0,
      maxHeaderLineH: '50px',
      compPercent: true,
      searchList: [],
      selectCompMolde: {}
    };
  },
  computed: {
    compBackGroundColor() {
      return (model => {
        const isHave = model?.name == this.selectCompMolde?.name
        return isHave ? '#3894ff':'#E5E5E5'
      })
    },
    leftIconImg() {
      return this.leftConfig.isShow ? require('../assets/yincang-icon.png') : require('../assets/zhanshi-icon.png')
    },
    iconImg() {
      return this.rightConfig.isShow ? require('../assets/yincang-icon-1.png') : require('../assets/zhanshi-icon.png')
    },
    btnStyle() {
      return function (model) {
        const style = {
          color: "#565656",
          backgroundColor: "#fff",
          minWidth: `${model.width}px`,
          maxWidth: `${MAX_LEFT_BTN_WIDTH}px`
        }
        if (model.selected) {
          style.color = "#fff"
          style.backgroundColor = "#0052D9"
        } 
        
        return style;
      };
    },
    compleftConfigStyle() {
      const style = {
        color: "#565656",
        backgroundColor: "#fff"
      }
      if (this.compPercent) {
        style.color = "#fff"
        style.backgroundColor = "#0052D9"
      }   
      return style;
    },
    compRightConfigStyle() {
      const style = {
        color: "#565656",
        backgroundColor: "#fff"
      }
      if (!this.compPercent) {
        style.color = "#fff"
        style.backgroundColor = "#0052D9"
      }   
      return style;
    },   
  },
  mounted() {
    const _this = this
    window.onresize = () => {
      return (() => {
        _this.loadBgLayout()
      })()
    }
  },
  methods: {
    filterCaseDataListDo() {
      this.$refs.searchTool.keyWords = ""
      let lastIndex = 0
      let haveSelected = false
      let newOriginDataList = [...this.originTableDataList]//JSON.parse(JSON.stringify(this.originTableDataList))

      for (const index in this.leftCaseTitleList) {
        const model = this.leftCaseTitleList[index];
        model.selected = false
        const isSelect = model.list.some(m => {
          return m.selected == true
        })
        if (isSelect) {
          lastIndex = index
          haveSelected = isSelect
          model.selected = isSelect
        }
      }

      if (haveSelected) {
        for (const index in this.leftCaseTitleList) {
          const caseItem = this.leftCaseTitleList[index]
          const list = caseItem.list
          const newCaseList = []
          
          if (index < lastIndex) {
            if (caseItem.selected) {
              for (const nItem of newOriginDataList) {
                const clList = nItem.list
                const str = clList[index]
                const isHave = list.some(m => {
                  return m.selected == true && m.name == str
                })
                if (isHave) {
                  newCaseList.push(nItem)
                } 
              }
              if (newCaseList.length > 0) {
                newOriginDataList = newCaseList
              }
            } else {
              for (const nItem of newOriginDataList) {
                newCaseList.push(nItem)
              }
              if (newCaseList.length > 0) {
                newOriginDataList = newCaseList
              }
            }
          } 
          else if (index == lastIndex) {
            for (const nItem of newOriginDataList) {
              const clList = nItem.list
              const str = clList[index]
              if (str) {
                const isHave = list.some(m => {
                  return m.selected == true && m.name == str
                })
                if (isHave) {
                  newCaseList.push(nItem)
                } 
              } else {
                newCaseList.push(nItem)
              }
            }
            if (newCaseList.length > 0) {
              newOriginDataList = newCaseList
            }
          }
        }
      }
      this.tableDataList = newOriginDataList
      this.searchList = [...newOriginDataList]
      this.getTableHeight()
    },
    singleSelectCaseDo(item, model) {
      clearTimeout(this.doubleConfig.doubleTimer)
      this.doubleConfig.doubleTimer = null
      const _this = this
      this.doubleConfig.doubleTimer = setTimeout(() => {
        // model.selected = !model.selected
        item.selected = !item.selected
        if (item.selected) {
          model.list.map(m => {
            if (m.name != item.name) {
              m.selected = false
            }
          })
        }
        setTimeout(() => {
          _this.filterCaseDataListDo()
        }, SETTIMEOUT)
        clearTimeout(_this.doubleConfig.doubleTimer)
         _this.doubleConfig.doubleTimer = null
      }, 300);
    },
    
    doubleSelectCaseDo(item, model) {
      console.log(model)
      clearTimeout(this.doubleConfig.doubleTimer)
      this.doubleConfig.doubleTimer = null
      // model.selected = !model.selected
      item.selected = !item.selected
      const _this = this
      setTimeout(() => {
        _this.filterCaseDataListDo()
      }, SETTIMEOUT)
    },
    searchKeyWords(keyWords) {
      const regExp = new RegExp(keyWords,  'i')
      const arrList = this.searchList //this.originTableDataList
      const regexpList = arrList.filter(model => {
        return model?.name?.search(regExp) != -1
      })
      this.tableDataList = regexpList
      
      // if (keyWords) {
        this.getTableHeight()
      // } else {
      //   this.tableH = this.oriTableH
      // }
    },
    dataPercentDo() {
      this.compPercent = true
    },
    dataDifferDo() {
      this.compPercent = false
    },
    selectTitleDo(item, caseModel) {
      const _this = this;
      this.doubleConfig.clickNum ++
      if (this.doubleConfig.doubleTimer) {
        return
      }
      this.doubleConfig.doubleTimer = setTimeout(() => {
        if (_this.doubleConfig.clickNum >= 2) {
          item.selected = !item.selected
        } else {
          item.selected = !item.selected
          if (item.selected) {
            caseModel.list.map(m => {
              if (m.name != item.name) {
                m.selected = false
              }
            })
          }
        }
        _this.doubleConfig.clickNum = 0
        _this.doubleConfig.doubleTimer = null
        setTimeout(() => {
          _this.caseConfirmDo()
        }, SETTIMEOUT)
      }, SETTIMEOUT);
    },
    resetCaseAllDo(model) {
      for (const m of model.list) {
        m.selected = false;
      }
      const _this = this;
      setTimeout(() => {
        _this.filterCaseDataListDo()
      }, SETTIMEOUT)
    },
    exchangeCaseDo() {
      this.leftConfig.isShow = !this.leftConfig.isShow
    },
    exchangeDo() {
      this.rightConfig.isShow = !this.rightConfig.isShow
      const _this = this;
      // setTimeout(() => {
        _this.loadBgLayout()
      // }, 100)
    },
    async caseConfirmDo() {
      // this.tableDataList = JSON.parse(JSON.stringify(this.originTableDataList))
      // this.columnsList = JSON.parse(JSON.stringify(this.originColumnsList))
      this.scrollColumnsList = [...this.originColumnsList]//JSON.parse(JSON.stringify(this.originColumnsList))

      let haveSelected = false
      let lastIndex = 0
      for (const index in this.caseTitleList) {
        const caseModel = this.caseTitleList[index];
        const isSelect = caseModel.list.some(m => {
          return m.selected == true
        })
        if (isSelect) {
          haveSelected = isSelect
          lastIndex = index
          caseModel.isSelected = isSelect
        }
      }

      // let isMore = false
      if (haveSelected) {
        for (const index in this.caseTitleList) {
          const caseItem = this.caseTitleList[index]
          const list = caseItem.list
          const newColumnsList = []

          if (index < lastIndex) {
            if (caseItem.isSelected) {
              for (const columnItem of this.scrollColumnsList) {
                const clList = columnItem.list
                const str = clList[index]
                const isHave = list.some(m => {
                  return m.selected == true && m.name == str
                })
                if (isHave) {
                  newColumnsList.push(columnItem)
                } 
              }
              if (newColumnsList.length > 0) {
                this.scrollColumnsList = newColumnsList
              }
            } else {
              for (const columnItem of this.scrollColumnsList) {
                newColumnsList.push(columnItem)
              }
              if (newColumnsList.length > 0) {
                this.scrollColumnsList = newColumnsList
              }
            }

          } 
          else if (index == lastIndex) {
            for (const columnItem of this.scrollColumnsList) {
              const clList = columnItem.list
              const str = clList[index]
              if (str) {
                const isHave = list.some(m => {
                  return m.selected == true && m.name == str
                })
                if (isHave) {
                  newColumnsList.push(columnItem)
                } 
              } else {
                newColumnsList.push(columnItem)
              }
            }
            if (newColumnsList.length > 0) {
              this.scrollColumnsList = newColumnsList
            }
          }
        }
      }
      this.setColumnsData()
    },
    setColumnsData() {
      if (this.scrollColumnsList.length > COLUMNS_LEN) {
        this.columnsList = this.scrollColumnsList.slice(0, COLUMNS_LEN)
      } else {
        this.columnsList = this.scrollColumnsList
      }
    },
    resetAllDo(caseModel) {
      for (const m of caseModel.list) {
        m.selected = false;
      }
      const _this = this;
      setTimeout(() => {
        _this.caseConfirmDo()
      }, SETTIMEOUT)
    },
    missDo() {
      this.compStyle.isShow = false
    },
    popCompareDo(event) {
      const pageX = event.pageX - 9 + 'px'
      const pageY = event.clientY - (160 + 20) + 'px'
      this.compStyle.left = pageX
      this.compStyle.top = pageY
      this.compStyle.isShow = !this.compStyle.isShow
    },
    getTableHeight() {
      const headerH = parseFloat(this.maxHeaderLineH.split('px').shift())
      const bottomScrollBarH = 18
      const rowH = 50//55
      const lineH = 1
      const count = this.tableDataList.length
      const totalH =  count * (rowH + lineH) + headerH + bottomScrollBarH      
      const tableBoxTop = this.$refs.tableBox.offsetTop
      const clientHeight = document.body.clientHeight
      const hei = clientHeight - tableBoxTop - 102 - 13

      this.tableH = totalH > hei ? hei : totalH

      if (this.tableH < (headerH + 80)) {
        this.tableH = headerH + 80
      }
      if (this.oriTableH == 0) {
        this.oriTableH = this.tableH
      }
    },
    compSortClick(item) {
      this.selectCompMolde = item
      const name = item.name
      if (this.selectHeaderName != name) {
        this.compRise = false;
        this.selectHeaderName = name;
        this.cliclNum = 0
      }
      this.cliclNum ++
      if (!this.clickTimer) {
        this.clickTimer = setTimeout( async () => {
          if (this.cliclNum >= 2) {
            if (item.perfermax == item.compPerfermax) {
              if (item.perfermax) {
                this.preferMax = false
              } else {
                this.preferMax = true
              }
            } else {
              this.preferMax = true
            }
            item.perfermax = this.preferMax
            item.compPerfermax = this.preferMax
           
            if (this.preferMax) {
              for (const model of this.tableDataList) {
                const item1 = model[name]
                const leftM = item1?.leftM
                const rightM = item1?.rightM
                if (leftM) {
                  leftM.perfermax = this.preferMax
                }
                if (rightM) {
                  rightM.perfermax = this.preferMax
                }
                
                const rightValue = parseFloat(rightM?.value)
                const leftMValue = parseFloat(leftM?.value)
                if (!isNaN(rightValue) && !isNaN(leftMValue)) {
                  if (rightValue > leftMValue) {
                    item1.state = CompareState.reduce
                  } else if (rightValue == leftMValue) {
                    item1.state = CompareState.nochange
                  } else if (rightValue < leftMValue) {
                    item1.state = CompareState.rise
                  }
                } else {
                  item1.state = CompareState.partial
                } 
              }
            } else {
              for (const model of this.tableDataList) {
                const item1 = model[name]
                const leftM = item1?.leftM
                const rightM = item1?.rightM
                if (leftM) {
                  leftM.perfermax = this.preferMax
                }
                if (rightM) {
                  rightM.perfermax = this.preferMax
                }
                const rightValue = parseFloat(rightM?.value)
                const leftMValue = parseFloat(leftM?.value)
                if (!isNaN(rightValue) && !isNaN(leftMValue)) {
                  if (rightValue < leftMValue) {
                    item1.state = CompareState.reduce
                  } else if (rightValue == leftMValue) {
                    item1.state = CompareState.nochange
                  } else if (rightValue > leftMValue) {
                    item1.state = CompareState.rise
                  }
                } else {
                  item1.state = CompareState.partial
                } 
              }
            }

            const params = this.$route.params
            const id = params.id
            const cid = params.cid
            await updateTrialSheet({
              rowsList: this.leftRowList,
              columnsList: this.leftColumnsList,
              sheetId: id
            })

            await updateTrialSheet({
              rowsList: this.rightRowList,
              columnsList: this.rightColumnsList,
              sheetId: cid
            })
            
        } else {
          this.compRise = !this.compRise
           //上升多 -> 上升少 -> 无变化 -> 减小少 -> 减小多

          //右边缺失
          const rightPartialList = this.tableDataList.filter(m => {
            return (m[name].state == CompareState.partial && Number.isNaN(parseFloat(m[name]?.rightM?.value)))
          })
          //上升
          const riseList = this.tableDataList.filter(m => {
            return m[name].state == CompareState.rise
          })
          if (this.compPercent) {
            riseList.sort((m1, m2) => {
              return m2[name].comp - m1[name].comp
            })
          } 
          // else {
          //   riseList.sort((m1, m2) => {
          //     return m1[name].compDiff - m2[name].compDiff
          //   })
          // }

          //无变化
          const nochangeList = this.tableDataList.filter(m => {
            return m[name].state == CompareState.nochange
          })

          //减少
          const reduceList = this.tableDataList.filter(m => {
            return m[name].state == CompareState.reduce
          })
          if (this.compPercent) {
            reduceList.sort((m1, m2) => {
              return m1[name].comp - m2[name].comp
            })
          }
          //  else {
          //   reduceList.sort((m1, m2) => {
          //     return m2[name].compDiff - m1[name].compDiff
          //   })
          // }

          //左边缺失
          const leftPartialList = this.tableDataList.filter(m => {
            return (m[name].state == CompareState.partial && Number.isNaN(parseFloat(m[name]?.leftM?.value)))
          })

          //无数据
          const nodataList = this.tableDataList.filter(m => {
            return m[name].state == CompareState.nodata
          })

          if (this.compRise) {
            if (this.compPercent) {
              const list = rightPartialList.concat(riseList, nochangeList, reduceList, leftPartialList, nodataList)
              this.tableDataList = list;
            } else {
              riseList.sort((m1, m2) => {
                return m1[name].compDiff - m2[name].compDiff
              })
              reduceList.sort((m1, m2) => {
                return m1[name].compDiff - m2[name].compDiff
              })
              /*
              const list = rightPartialList.concat(riseList, nochangeList, reduceList, leftPartialList, nodataList)
              */
              const list = rightPartialList.concat(riseList, reduceList, nochangeList, leftPartialList, nodataList)
              this.tableDataList = list;
            }
          } else {
            if (this.compPercent) {
              this.tableDataList = this.tableDataList.reverse()
            } else {
              riseList.sort((m1, m2) => {
                return m2[name].compDiff - m1[name].compDiff
              })
              reduceList.sort((m1, m2) => {
                return m2[name].compDiff - m1[name].compDiff
              })
              /*
              const list = leftPartialList.concat(reduceList, nochangeList, riseList, rightPartialList, nodataList)
              */
              const list = leftPartialList.concat(reduceList, riseList, nochangeList, rightPartialList, nodataList)
              this.tableDataList = list;
            }
          }
        }
        this.cliclNum = 0
        clearTimeout(this.clickTimer)
        this.clickTimer = null
      }, 300);
      }
    },
    getItemValue(item) { 
      const v = item?.value ? item.value : ""
      const l = parseFloat(v)
      return Number.isNaN(l) ? "-" : v
    },
    getRowStyle(item) {
      const value = item?.value ? item.value : ""
      const l = parseFloat(value)
      let color = ''
      if (Number.isNaN(l)) {
        color = '#383838'
      } else {
        color = '#0052D9'
      }
      return {color: color}
    },
    //根据表头label设表格列宽度2
    flexTrialMaxWidth(rowModel, index) {
      if (rowModel?.name) {
        const str = (parseInt(index) + 1) + rowModel?.name;
        const flexWidth = getStrWidthBySpan(str, 13, 500) + 30 + 5
        if (flexWidth >= this.trialMaxWidth) {
          this.trialMaxWidth = flexWidth;
        }
      }
    },
    pushPage(newId) {
      if (!newId) {
        return
      }
      const routeData = this.$router.resolve({
        name: "Trial",
        params: { id: newId },
      });
      window.open(routeData.href, "_blank");
    },
    getBottomImg() {
      return this.showMore ?  require("@/assets/sheet-fold-icon.png") : require("@/assets/sheet-more-icon.png") 
    },
    getBottomTitle() {
      return this.showMore ? "FOLD" : "MORE"
    },
    getListData() {
      this.leftInfo.list = []
      for (const model of this.leftInfo.allList) {
        if (model.title.toLocaleLowerCase() == "env") {
          const envList = model.value.split(";")
          for (const envStr of envList) {
            this.leftInfo.list.push({"title": model.title, "value": envStr})
          }
        } else {
          this.leftInfo.list.push(model)
        }
      }
      this.rightInfo.list = []
      for (const model of this.rightInfo.allList) {
        if (model.title.toLocaleLowerCase() == "env") {
          const envList = model.value.split(";")
          for (const envStr of envList) {
            this.rightInfo.list.push({"title": model.title, "value": envStr})
          }
        } else {
          this.rightInfo.list.push(model)
        }
      }
    },
    clickDo() {
      this.showMore = !this.showMore
      if (this.showMore && this.rightConfig.isShow || !this.showMore && !this.rightConfig.isShow) {
        this.rightConfig.isShow = !this.rightConfig.isShow
      } 
      if (this.showMore && this.leftConfig.isShow || !this.showMore && !this.leftConfig.isShow) {
        this.leftConfig.isShow = !this.leftConfig.isShow
      } 
      // this.getListData()
    },
    titleCase(str) {
      const newStr = str.slice(0,1).toUpperCase() + str.slice(1).toLowerCase();
      return newStr;
    },
    getCompareColor(model) {
      let bgColor = "#ECF2FE"
      if (model?.state == CompareState.nochange) {
        bgColor = "#ECF2FE"
      } else if (model?.state == CompareState.rise) {
        //FFEBEB
        let showColor = '#FFEBEB' 
        if (model.comp <= 20) {
          showColor = '#FFEBEB'
        } else if (model.comp <= 40 && model.comp > 20) {
          showColor = '#ffd2d2'
        } else if (model.comp <= 60 && model.comp > 40) {
          showColor = '#ffb8b8'
        } else if (model.comp <= 80 && model.comp > 60) {
          showColor = '#ff9f9f'
        } else if (model.comp > 80) {
          showColor = '#ff8989'
        }
        if (this.compPercent) {
          bgColor = showColor
        } else {
          bgColor = '#ff8989'
        }
      } else if (model.state == CompareState.reduce) {
        //EEFCE8
        let showColor = '#EEFCE8' 
        if (model.comp <= 20) { 
          showColor = '#EEFCE8'
        } else if (model.comp <= 40 && model.comp > 20) { 
          showColor = '#ddf9d1'
        } else if (model.comp <= 60 && model.comp > 40) { 
          showColor = '#cdf6bb'
        } else if (model.comp <= 80 && model.comp > 60) { 
          showColor = '#bcf3a4'
        } else if (model.comp > 80) { 
          showColor = '#aef191'
        } 
        if (this.compPercent) {
          bgColor = showColor
        } else {
          bgColor = '#aef191'
        }
      } else if (model.state == CompareState.nodata) {
        bgColor = "#ECF2FE"
      } else if (model.state == CompareState.partial) {
        if (! Number.isNaN(parseFloat(model.rightM?.value))) {
          bgColor = '#aef191'
        } else if (! Number.isNaN(parseFloat(model.leftM?.value))) {
          bgColor = "#ff8989"
        }
      }
      return bgColor
    },
    getCompareValue(model) {
      let haf = ""
      let m = "-"
      if (model.state == CompareState.nochange || model.state == CompareState.partial || model.state == CompareState.nodata) {
        haf = ""
      } else {
        if (parseFloat(model.rightM?.value) > parseFloat(model.leftM?.value)) {
          haf = "↑"
        } else {
          haf = "↓"
        }
        if (this.compPercent) {
          if (Number.isNaN(parseFloat(model.comp))) {
            m = "-"
          } else {
            m = `${haf} ${model.comp}%`
          }
        } else {
          m = model?.compDiff
        }
      }      
      return m  
    },
    loadBgLayout() {
      const _this = this
      this.$nextTick(() => {
        // const clientWidth = document.body.clientWidth - 20
        const bgWidth = _this.$refs.refBg.clientWidth
        _this.leftConfig.bgShow = bgWidth >= 550
        _this.rightConfig.bgShow = bgWidth >= 550
        // let wid = 0
        // if (_this.rightConfig.leftWidth.split('px')?.length > 0) {
        //   wid = parseFloat(_this.rightConfig.leftWidth.split('px')[0]) 
        // }
        // const left = (clientWidth - bgWidth) / 2 
        // if (_this.rightConfig.isShow) {
        //   if (wid > left) {
        //     _this.rightConfig.bgLeft = wid + 20
        //   } else {
        //     _this.rightConfig.bgLeft = left 
        //   }
        // } else {
        //   _this.rightConfig.bgLeft = left 
        // }
        // _this.rightConfig.bgMarginLeft = _this.rightConfig.bgLeft  + 'px'
        _this.getTableHeight()
      })
    }
  },
  async created() {
    this.loading = true
    document.title = 'compare'
    const params = this.$route.params;
    const href = window.location.href.split("/benchmark").shift();
    const id = params.id
    const statusData = await getQueryStatus(id, ResourceType.SHEET);
    let sheets = []
    try {
      sheets = await getQueryMetricsBySheet(id);
    } catch (error) {
      console.log(error)
    }
    this.dataList = sheets;
  
    const compareId = params.cid
    const compareStatusData = await getQueryStatus(compareId, ResourceType.SHEET);
    let compareSheets = []
    try {
      compareSheets = await getQueryMetricsBySheet(compareId);
    } catch (error) {
      console.log(error)
    }
    this.compareDataList = compareSheets
    
    this.leftInfo.url = href + "/benchmark/sheet/" + id
    
    const titleList = ["title", "description"]
    if (statusData.sheet?.annotationsMap) {
      for (const l1 of statusData.sheet.annotationsMap) {
        const have = titleList.some(a => {
          return a == l1[0]
        })
        if (!have) {
          const m = l1[0]
          titleList.push(m)
        }
      }
    }

    if (compareStatusData?.sheet?.annotationsMap) {
      for (const l2 of compareStatusData.sheet.annotationsMap) {
        const have = titleList.some(a => {
          return a == l2[0]
        })
        if (!have) {
          const m = l2[0]
          titleList.push(m)
        }
      }
    }

    // this.showMore = titleList.length > 2
    for (const title of titleList) {
      const dd = statusData.sheet?.annotationsMap.filter(map => {
        return map[0].toLocaleLowerCase() == title.toLocaleLowerCase()
      })
      if (dd?.length > 0) {
        const item = {title: title, value: dd[0][1]}
        this.leftInfo.allList.push(item)
      } else {
        const item = {title: title, value: ""}
        this.leftInfo.allList.push(item)
      }
    }
    
    for (const title of titleList) {
      const dd = compareStatusData.sheet?.annotationsMap.filter(map => {
        return map[0].toLocaleLowerCase() == title.toLocaleLowerCase()
      })
      if (dd?.length > 0) {
        const item = {title: title, value: dd[0][1]}
        this.rightInfo.allList.push(item)
      } else {
        const item = {title: title, value: ""}
        this.rightInfo.allList.push(item)
      }
    }
    this.leftRowList = statusData?.sheet?.rowsList
    this.rightRowList = compareStatusData?.sheet?.rowsList
    this.getListData()

    this.rightInfo.url = href + "/benchmark/sheet/" + compareId
    let noList = []
    if (statusData?.sheet?.rowsList?.length > 0) {
      noList = statusData?.sheet?.rowsList
    }
    for (const row of compareStatusData?.sheet?.rowsList) {
      const have = noList.some(m => {
        return m.name == row.name
      })
      if (!have) {
        noList.push(row)
      }
    }

    if (noList?.length > 0) {
      this.rowsList = noList
    }

    let columnsList = []
    if (statusData?.sheet?.columnsList?.length > 0) {
      columnsList = statusData?.sheet?.columnsList
      this.leftColumnsList = statusData?.sheet?.columnsList
    }
    if (compareStatusData?.sheet?.columnsList?.length > 0) {
      this.rightColumnsList = compareStatusData?.sheet?.columnsList
    }
    for (const column of compareStatusData?.sheet?.columnsList) {
      const li = columnsList.filter(mod => {
        return mod.name == column.name
      })
      if (li.length > 0) {
        li[0].compPerfermax = column.perfermax
      } else {
        column.compPerfermax = column.perfermax
        column.perfermax = false
        columnsList.push(column)
      }
    }
    this.originColumnsList = columnsList
    // this.columnsList = columnsList
    if (this.originColumnsList?.length > 0) {
      this.selectHeaderName = this.originColumnsList[0].name
    }

    const newDataList = []
    const caseTitleList = []
    let maxHeight = 0
    this.leftCaseTitleList = []
    for (const index in this.rowsList) {
      const indexNum = parseInt(index) + 1
      const rowItem = this.rowsList[index]
      const leftListArr = rowItem.name.split("-")
      rowItem.list = leftListArr
      for (const nameIndex in leftListArr) {
        const cName = leftListArr[nameIndex]
        if (this.leftCaseTitleList.length > nameIndex) {
          const h = this.leftCaseTitleList[nameIndex].list.some(m => {
            return m.name == cName
          })
          if (!h) {
            this.leftCaseTitleList[nameIndex].list.push({name: cName, selected: false})
          }
        } else {
          this.leftCaseTitleList.push({selected: false, list: [{name: cName, selected: false}]})
        }
      }
      this.flexTrialMaxWidth(rowItem, indexNum)
      const leftArr = sheets.filter(item => {
        return item?.name == rowItem?.name
      })
      const rightArr = compareSheets.filter(item => {
        return item?.name == rowItem?.name
      })      
      
      let leftItem = {}
      let rightItem = {}
      if (leftArr.length > 0) {
        leftItem = leftArr[0]
      }
      if (rightArr.length > 0) {
        rightItem = rightArr[0]
      }
      let model = {
        name: rowItem.name,
        leftTrialid: leftItem?.trialid,
        rightTrialid: rightItem?.trialid,
        list: leftListArr,
      }
      
      for (const columnItem of this.originColumnsList) {
        const leftMetricsList = leftItem?.metricsList?.filter(m => {
          return m.name == columnItem.name
        })
        const rightMetricsList = rightItem?.metricsList?.filter(m => {
          return m.name == columnItem.name
        })
        let leftMetricsM = null
        if (leftMetricsList?.length > 0) {
          leftMetricsM = leftMetricsList[0]
        }
        let rightMetricsM = null
        if (rightMetricsList?.length > 0) {
          rightMetricsM = rightMetricsList[0]
        }
        let leftValue = parseFloat(leftMetricsM?.value)
        let rightValue = parseFloat(rightMetricsM?.value)
        let compDiff
        let comp
        let state = CompareState.nochange
        if (Number.isNaN(leftValue) || Number.isNaN(rightValue)) {
          comp = "-"
          state = CompareState.partial
          if ( Number.isNaN(leftValue) && Number.isNaN(rightValue)) {
            state = CompareState.nodata
          }
          compDiff = comp
        } else {
          if (rightValue < leftValue) {
            if (leftMetricsM?.perfermax || rightMetricsM?.perfermax) {
              state = CompareState.rise
            } else {
              state = CompareState.reduce
            }
          } else if (rightValue > leftValue) {
            if (leftMetricsM?.perfermax || rightMetricsM?.perfermax) {
              state = CompareState.reduce
            } else {
              state = CompareState.rise
            }
          } else {
            state = CompareState.nochange
          }
          if (leftValue == 0) {
            comp = "-"
          } else {
            comp = Math.abs(parseFloat((rightValue - leftValue) / leftValue))
            comp = comp.toFixed(3)
            comp = Math.floor(comp*1000)/1000 * 100
            comp = comp.toFixed(1) 
          }
          
          const num = parseFloat(rightValue) - parseFloat(leftValue)
          let m = num
          if (num != 0) {
            for (let i = 2; i < 5; i++) {
              m = num.toFixed(i) 
              if (m != 0) {
                break
              }
            }
          }
          compDiff = m
        }
        model[`${columnItem.name}`] = {
          leftM: leftMetricsM,
          rightM: rightMetricsM,
          comp: comp,
          compDiff: compDiff,
          state: state
        }

        if (index == 0) {
          let showName = ""
          const tList =  columnItem.name.split(".")
          const tcList = []
          
          for (const key in tList) {
            const s = tList[key]
            if (s) {
              tcList.push(s)
              let tW = getStrWidthBySpan(s, 12, 400) 
              let showTip = false
              if (tW > MAX_LEFT_BTN_WIDTH) {
                tW = MAX_LEFT_BTN_WIDTH
                showTip = true
              } else if (tW <= MIN_LEFT_BTN_WIDTH) {
                tW = MIN_LEFT_BTN_WIDTH
              }
              if (caseTitleList.length > key) {
                const li = caseTitleList[key]
                const isHave = li.some(model => {
                  return model?.name == s
                })
                if(!isHave) {
                  const model = {
                    name: s,
                    selected: false,
                    width: tW,
                    showTip: showTip
                  }
                  li.push(model)
                }
              } else {
                const model = {
                  name: s,
                  selected: false,
                  width: tW,
                  showTip: showTip
                }
                const li = [model]
                caseTitleList.push(li)
              }
            }
          }  

          columnItem.list = tcList

          for (const key in tcList) {
            const keyIndex = parseInt(key) + 1
            const str = tcList[key];
            if (keyIndex % 2 == 0) {
              if (keyIndex == tcList.length) {
                showName = showName + str 
              } else {
                showName = showName + str + '\n.'
              }
            } else {
              if (keyIndex == tcList.length) {
                showName = showName + str
              } else {
                showName = showName + (str + '.')
              }
            }
          }
          if (tcList.length == tList.length) {
            columnItem.showName = showName
          } else {
            columnItem.showName = showName + '.'
          }
          
          const rowLen = Math.floor(tcList?.length / 2)
          const columnLen = tcList?.length % 2
          const colH = 18 * (rowLen + columnLen)
          if (colH > maxHeight) {
            maxHeight = colH 
          }
        }
      }
      newDataList.push(model)
    }
    maxHeight = maxHeight > 50 ? maxHeight : 50
    this.maxHeaderLineH = maxHeight + 20 + 5 + 'px'
    this.tableDataList = newDataList
    this.originTableDataList = [...this.tableDataList]//JSON.parse(JSON.stringify(this.tableDataList))
    this.searchList = [...this.tableDataList]//JSON.parse(JSON.stringify(this.tableDataList))
    this.caseTitleList = []
    for (const titleList of caseTitleList) {
      const model = {
        isSelected: false,
        list: titleList
      }
      this.caseTitleList.push(model)
    }

    this.scrollColumnsList = [...this.originColumnsList]//JSON.parse(JSON.stringify(this.originColumnsList))
    this.setColumnsData()
    this.rightConfig.isShow = true
    this.leftConfig.isShow = true
    this.loadBgLayout()
    this.loading = false

    const _this = this
    this.$nextTick(() => {
      const dom = _this.$refs.dragTable.$refs.scrollBarRef.wrapRef//bodyWrapper;
      dom.addEventListener('scroll',()=>{         
        const tableWidth = dom.offsetWidth
        const scrollLeft = dom.scrollLeft
        const scrollWidth = dom.scrollWidth
        if(scrollLeft != 0 && (Math.round(scrollWidth-tableWidth) <= Math.round(scrollLeft))){
          if (_this.columnsList.length < _this.scrollColumnsList.length) {
            const startIndex = _this.columnsList.length
            const endIndex = startIndex + 8
            const scollList = _this.scrollColumnsList.slice(startIndex, endIndex)
            _this.columnsList = _this.columnsList.concat(scollList)
          }          
        }
      }) 
    })
  },
  components: {
    CompareClickDialog,
    SearchTool
  },
};
</script>
<style lang='less' scoped>
.sheetComparePage {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0px 10px;
}
.bg {
  // width: calc(100% - 850px);
  // min-width: 1200px;
  // height: 100%;
  // margin: 0 auto;
  // background-color: #f5f5f5;
  // max-width: 2000px;
  margin: 0 auto;
  min-width: 1200px;
  width: calc(100% - 850px);
  max-width: 2000px;
}

@media screen and (max-width: 1800px) {
  .bg {
    margin: 0 auto;
    width: calc(100% - 380px);
    min-width: 549px;//700px;
  }
}

.show-left-content-box {
  position: fixed;
  left: 15px;
  top: 90px;
  z-index: 9999;
  img {
    height:20px;
    width:20px;
    cursor: pointer;
  }
}

.show-right-content-box {
  position: fixed;
  right: 15px;
  top: 90px;
  z-index: 9999;
  img {
    height:20px;
    width:20px;
    cursor: pointer;
  }
}

.right-content-box {
  width: 200px;
  height: calc(100vh - 180px);
  right: 10px;
  background-color: #fff;
  position: fixed;
  top: 130px;
  // overflow-x: hidden;
	// overflow-y: auto;
  z-index: 9999;
  border-radius: 6px;
  padding: 0px;

  .content-box {
    height: calc(100% - 110px);
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .right-box {
    margin-top: 10px;
    background-color: #fff;
    border-radius: 8px;
    border: 1px solid #b9b9b9;
    position: relative;
    padding: 15px 2px 5px 2px;
    .left-btn {
      margin: 2px;
      min-width: 60px;
      padding: 1px 5px;
      font-size: 12px;
      // height: 40px;
      font-weight: 400;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .resetBtn {
      position: absolute;
      top: 1px;
      right: 3px;
      font-size: 13px;
      background-color: rgba(#fff, #fff, #fff, 0);
      cursor: pointer;
      color: #0052d9;
      height: 14px;
      width: 14px;
      img {
        object-fit: contain;
        height: 11px;
        width: 11px;
      }
    }
  }
  .left-confirm-btn {
    margin-top: 20px;
    width: 120px;
  }
}



.left-content-box {
  width: 200px;
  height: calc(100vh - 180px);
  left: 10px;
  background-color: #fff;
  position: fixed;
  top: 130px;
  overflow-x: hidden;
	overflow-y: scroll;
  z-index: 999;
  border-radius: 6px;
  padding:0px;

  .left-box {
    margin-top: 10px;
    background-color: #fff;
    border-radius: 8px;
    border: 1px solid #b9b9b9;
    position: relative;
    padding: 15px 2px 5px 2px;
    .left-btn {
      margin: 2px;
      min-width: 60px;
      // max-width: 100%;
      padding: 1px 5px;
      font-size: 12px;
      font-weight: 400;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .resetBtn {
      position: absolute;
      top: 1px;
      right: 3px;
      font-size: 13px;
      background-color: rgba(#fff, #fff, #fff, 0);
      cursor: pointer;
      color: #0052d9;
      height: 14px;
      width: 14px;
      img {
        object-fit: contain;
        height: 11px;
        width: 11px;
      }
    }
  }

  .left-confirm-btn {
    margin-top: 20px;
    width: 120px;
  }
}



.left-bottom-box {
  position: absolute;
  bottom: 0;
  width: 100%;
  border: 1px solid #b9b9b9;
  border-radius: 6px;
  padding: 10px 8px;
  height: 90px;
  .bottom-top-p {
    color: #333;
    font-size: 14px;
    font-weight: 500;
  }
  .left-bottom-btn-box {
    justify-content: space-around;
    display: flex;
    flex-direction: row;
    margin-top: 10px;
    .btn {
      color: #333;
      font-size: 13px;
      font-weight: 400;
      padding: 5px;
      width: 80px;
      height: 40px;
    }
  }
}

.top-box {
  width: 100%;
  padding-bottom: 20px;
  background-color: #ffffffff;
  margin-top: 40px;
  display: flex;
  border-radius: 6px;
  position: relative;

  .top-url-box {
    width: calc(100% / 2);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px 60px 0px 40px;
    .top-line {
      height: 5px;
      width: 100%;
      background-color: #fbad15ff;
    }
    .top-line-right {
      background-color: #0050b3ff;
    }
    .top-url {
      margin-top: 20px;
      width: 100%;
      height: 45px;
      background-color: #f5f5f5ff;
      background-blend-mode: normal;
      display: flex;
      justify-content: center;
      align-items: center;
      a {
        text-decoration: none;
        color: #0067e6ff;
        opacity: 1;
        font-size: 14px;
        font-weight: 400;
        word-break: break-word;
      }
    }
  }

  .top-url-right-box {
    padding: 0px 40px 0px 60px;
    align-items: flex-end;
  }

  .top-row-line {
    position: absolute;
    width: 0px;
    background-color: #ccccccff;
    top: 10px;
    bottom: 10px;
    opacity: 1;
    border: 1px solid #e5e5e5ff;
    background-color: #ccccccff;
    left: calc(100% / 2);
  }
}

.info-box-bg {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  padding-bottom: 25px;
  margin-top: 30px;
}

.info-box {
  padding: 0px 0px 30px 0px;
  background-color: #ffffff;
  display: flex;
  position: relative;

  .info-left-box {
    display: flex;
    flex-direction: column;
    width: calc(100% / 2);
    .info-left-row-box {
      display: flex;
      padding-right: 60px;
      min-height: 40px;
      margin-top: 20px;
      .info-left-line {
        background-color: #fbad15;
        width: 5px;
        height: 40px;
      }

      .info-left-title {
        height: 100%;
        width: 160px;
        background-color: #ecf2fe;
        background-blend-mode: normal;
        margin-left: 35px;
        font-size: 14px;
        font-weight: 400;
        display: flex;
        align-items: center;
        color: #565656;
        text-align: left;
        border-radius: 4px;
        padding-left: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .info-left-value {
        background-color: #f5f5f5;
        background-blend-mode: normal;
        height: 100%;
        width: calc(100% - 215px);
        margin-left: 15px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        display: flex;
        align-items: center;
        color: #565656;
        text-align: left;
        padding: 5px; 
        word-wrap: break-word;
        word-break: break-all;
      }
    }
  }

  .info-right-box {
    display: flex;
    flex-direction: column;
    width: calc(100% / 2);
    .info-right-row-box {
      display: flex;
      padding-left: 60px;
      min-height: 40px;
      margin-top: 20px;
      align-items: flex-end;
      .info-right-line {
        background-color: #fbad15;
        width: 5px;
        height: 40px;
      }

      .info-right-title {
        height: 100%;
        width: 160px;
        background-color: #ecf2fe;
        background-blend-mode: normal;
        margin-right: 35px;
        font-size: 14px;
        font-weight: 400;
        display: flex;
        align-items: center;
        color: #565656;
        text-align: left;
        border-radius: 4px;
        padding-left: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .info-right-value {
        background-color: #f5f5f5;
        background-blend-mode: normal;
        height: 100%;
        width: calc(100% - 215px);
        margin-right: 15px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        display: flex;
        align-items: center;
        color: #565656;
        text-align: left;
        padding: 5px; 
        word-wrap: break-word;
        word-break: break-all;
      }
    }
  }
  .info-line {
    position: absolute;
    top: 20px;
    bottom: 30px;
    width: 0px;
    background-color: #ccccccff;
    opacity: 1;
    border: 1px solid #e5e5e5ff;
    background-color: #ccccccff;
    left: calc(100% / 2);
  }
}

.info-bootom-box {
  margin: 0 auto;
  display: flex;
  height: 13px;
  align-items: center;
  width: 100%;
  background-color: #fff;
  height: 50px;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  border-radius: 6px;

  .info-bootom-title {
    color: #00baad;
    font-size: 12px;
    cursor: pointer;
    font-weight: 500;
  }
  img {
    cursor: pointer;
    height: 11px;
    width: 11px;
    object-fit: contain;
  }
}

.table-box {
  padding: 20px 0px 10px 0px;
  background-color: #f5f5f5;
  .table {
    background-color: #f5f5f5;
  }



  .no-bg {
    color: #383838; //#0052D9;
    font-size: 13px;
    // cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    // white-space: nowrap;
    height: 50px;
    display: flex;
    font-weight: 400;
    align-items: center;

    .no {
      color: #0052D9;
      font-weight: 400;
      font-size: 13px;
      margin-left: 15px;
      white-space: nowrap;
    }

    .no-name {
      display: flex;
      height: 100%;
      margin-left: 10px;
      padding-right: 5;
      // word-wrap: break-word;
      word-wrap: break-word;
      text-align: left;
      align-items: center;
    }
  }

  .trial-box {
    display: flex;
    flex-direction: column;
    position: relative;
    align-items: center;
    .header-title {
      color: #000000;
      font-size: 13px;
      font-weight: 700;
      position: absolute;
      justify-content: center;
      bottom: 28px;
    }
    .header-box-bottom {
      margin-top: 8px;
      width: 100%;
      position: absolute;
      bottom: 1px;
    }
  }

  .header-bg {
    display: flex;
    flex-direction: column;
    // height: 60px;
    position: relative;
    .header-column-title {
      color: #000000;
      font-size: 13px;
      font-weight: 700;
      position: absolute;
      bottom: 16px;
      width: 100%;
      justify-content: center;
      line-height: 17px;
      white-space: pre-wrap;
    }
    img {
      height: 20px;
      width: 20px;
      position: absolute;
      right: 1px;
      bottom: 18px;
      cursor: pointer;
    }
    .header-bottom {
      display: flex;
      position: absolute;
      width: 100%;
      height: 10px;
      bottom: 5px;
      .bottom1 {
        width: calc((100% - 80px) / 2);
        background-color: #FBAD15;
      }
      .bottom2 {
        width: calc((100% - 80px) / 2);
        background-color: #0050B3;
      }
      .bottom3 {
        background-color: #E5E5E5;
        cursor: pointer;
        width: 80px;
      }
      .bottom {
        height: 100%;
      }
    }
  }

  .row-bg {
    display: flex;
    height: 50px;//55px;
    align-items: center;
    .row {
      padding: 0px 5px;
      display: flex;
      height: 100%;
      align-items: center;
      text-align: left;
      color: #383838;
      font-size: 13px;
    }
    .row1 {
      background-color: #ffffff;
      cursor: pointer;
      color: #0052D9;
      width: calc((100% - 80px) / 2);
    }
    .row2 {
      background-color: #F6F6F6;
      cursor: pointer;
      color: #0052D9;
      width: calc((100% - 80px) / 2);
    }
    .row3 {
      background-color: #ECF2FE;
      padding-right: 2px;
      width: 80px;
    }

  }
}

:deep(.el-table .cell) {
  padding: 0px !important;
}
:deep(.el-table td) {
  padding: 0px !important;
}

:deep(.el-table th) {
  padding: 0px !important;
  user-select: initial !important;
}

:deep(.el-table tr) {
  padding: 0px !important;
}
:deep(.el-table--border) {
  border: 0px !important;
}
:deep(.el-table__fixed-body-wrapper) {
  border: 1px solid #565656 !important;
  opacity: 1 !important;
  background: #FFFFFFFF !important;    
}
:deep(.el-table__body-wrapper) {
  border: 1px solid #565656 !important;
  opacity: 1 !important;
  background: #FFFFFFFF !important;    
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.05s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from {
  transform: translateX(20px);
}
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

:deep(.el-button) {
  min-height: 36px !important;
  white-space: pre-wrap !important;
  word-break:break-all !important;
}

</style>